import { Box, Grid, Stack, Typography, useMediaQuery } from '@mui/material'
import { useState } from 'react'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import BudgetCard from '../atoms/budget-card/BudgetCard'
import TotalBudget from './TotalBudget'
import { LineChart } from '@mui/x-charts'

import styles from './budgetTrackerStyle.module.scss'
import CategoryTab from './CategoryTab'
import PaymentTable from './PaymentTable'
import { BudgetAllocation } from './BudgetAllocation'
import { useSelector } from 'react-redux'

const lineChartXLabels = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
    'Jan', 'Feb', 'Mar', 'Apr', 'May'
] // Months

export const BudgetTab = () => {
    const paymentOverview = useSelector((s) => s.kazooEvent.paymentOverview)
    const lineChartPData = useSelector((s) => s.kazooEvent.spendingForcast)
    
    const paymentOverviewData = [
        {
            id: 1,
            icon: '/images/payment-pending.svg',
            status: 'Pending',
            count: paymentOverview[0],
        },
        {
            id: 2,
            icon: '/images/payment-upcoming.svg',
            status: 'Upcoming',
            count: paymentOverview[1],
        },
        {
            id: 3,
            icon: '/images/payment-paid.svg',
            status: 'Paid',
            count: paymentOverview[2],
        },
    ]

	const [value, setValue] = useState(0)
	const isSmallScreen = useMediaQuery('(max-width:991px)')

	const handleChange = (event, newValue) => {
		setValue(newValue)
	}
	function CustomTabPanel(props) {
		const { children, value, index, ...other } = props

		return (
			<div
				role="tabpanel"
				hidden={value !== index}
				id={`simple-tabpanel-${index}`}
				aria-labelledby={`simple-tab-${index}`}
				{...other}
			>
				{value === index && <Box>{children}</Box>}
			</div>
		)
	}

    const today = new Date()
    const month = today.getMonth() + 1

	const mainTabStyle = {
		'& .MuiTabs-scrollButtons.Mui-disabled': {
			opacity: '0.3',
		},
		'&.MuiTabs-root': {
			minHeight: 'unset',
		},
		'& .MuiButtonBase-root': {
			padding: '11px 16px',
			minHeight: 'unset',
			fontSize: '14px',
			fontFamily: 'Inter',
			fontWeight: '500',
			color: '#313131',
			textTransform: 'capitalize',
			'&.Mui-selected': {
				color: '#7CA6BD',

				'& svg path': {
					stroke: '#7CA6BD',
				},
			},
		},
		'& .MuiTabs-indicator': {
			backgroundColor: '#7CA6BD',
		},
		'@media (max-width: 599px)': {
			'& .MuiButtonBase-root': {
				padding: '8px',
			},
		},
	}

	return (
		<>
			<div className={styles.tabSection}>
				<Box sx={{ width: '100%' }} className={styles.tabs}>
					<Box sx={{ borderBottom: 1, borderColor: '#DFE4EB' }}>
						<Tabs
							value={value}
							onChange={handleChange}
							aria-label="basic tabs example"
							sx={mainTabStyle}
							variant={isSmallScreen ? 'scrollable' : 'standard'}
							scrollButtons={isSmallScreen ? 'auto' : false}
							allowScrollButtonsMobile={isSmallScreen}
						>
							<Tab
								label={
									<div className={styles.tabItem}>
										<span data-cy="Overview">Overview</span>
									</div>
								}
							/>
							<Tab
								label={
									<div className={styles.tabItem}>
										<span data-cy="Payments">Payments</span>
									</div>
								}
							/>
						</Tabs>
					</Box>

					<div className={styles.tabContentWrp}>
						<CustomTabPanel
							value={value}
							index={0}
							className={styles.content}
						>
							<Grid
								container
								spacing={{ xs: '10px', md: '20px' }}
							>
								<Grid size={{ xs: 12, md: 6, lg: 3 }}>
									<BudgetCard>
										<TotalBudget />
									</BudgetCard>
								</Grid>
								<Grid size={{ xs: 12, md: 6, lg: 3 }}>
									<BudgetCard heading="Budget Allocation">
										<BudgetAllocation />
									</BudgetCard>
								</Grid>
								<Grid size={{ xs: 12, md: 6, lg: 3 }}>
									<BudgetCard heading="Spending Forecast">
										<Box
											sx={{ width: '100%', height: "100%" }}
										>
											<Box
												sx={{
													width: '100%',
													height: 200,
												}}
											>
												<LineChart
													series={[
														{
															data: lineChartPData,
															label: '', // Required (even if hidden later)
															color: '#7CA6BD',
															boxShadow:
																'0px 6px 9px 0px #7CA6BD66',
															showMark: true,
															curve: 'catmullRom',
														},
													]}
													xAxis={[
														{
															scaleType: 'point',
															data: lineChartXLabels.slice(month, month + 6),
															tickLabelStyle: {
																fill: '#8692A4',
																fontSize: 12,
																fontWeight: 400,
																fontFamily:
																	'Inter',
															},
														},
													]}
													yAxis={[
														{
															tickLabelStyle: {
																fill: '#8692A4',
																fontSize: 12,
																fontWeight: 400,
																fontFamily:
																	'Inter',
															},
														},
													]}
													slotProps={{
														legend: {
															hidden: true,
														},
														series: {
															label: {
																hidden: true,
															},
														},
													}}
													sx={{
														'.MuiChartsLegend-root, .MuiChartsLegend-mark, .MuiChartsLegend-series':
															{
																display:
																	'none !important',
															},

														'.MuiChartsAxis-line': {
															stroke: '#a7a7a7',
															strokeWidth: 1,
														},

														'.MuiChartsGrid-line': {
															stroke: '#8692A4',
															strokeWidth: 0.8,
														},

														'.MuiLineElement-root':
															{
																strokeWidth: 1.5,
																boxShadow:
																	'0px 6px 9px 0px #7CA6BD66',
															},

														'.MuiMarkElement-root':
															{
																r: 4,
																fill: '#ffffff',
																stroke: '#7CA6BD',
																strokeWidth: 1,
															},
														// ✅ Hide ticks that overflow
														'.MuiChartsAxis-tick': {
															overflow: 'hidden',
														},

														// ✅ Prevent axis line overshoot
														'.MuiChartsAxis-left .MuiChartsAxis-line, .MuiChartsAxis-bottom .MuiChartsAxis-line':
															{
																shapeRendering:
																	'crispEdges',
																vectorEffect:
																	'non-scaling-stroke',
															},

														// ✅ Hide stray ticks manually if needed
														'.MuiChartsAxis-tick:nth-of-type(1)':
															{
																display: 'none',
															},
													}}
												/>

												{/* ✅ Custom Legend */}
												<Stack
													direction="row"
													alignItems="center"
													spacing={1}
													justifyContent="center"
													sx={{
														margin: "-10px !important"
													}}
												>
													<img
														src="/images/forecast-label.svg"
														alt=""
														style={{
															width: '16px',
															height: '16px',
															objectFit:
																'contain',
														}}
													/>
													<Typography
														sx={{
															fontSize: '12px',
															fontWeight: 400,
															color: '#313131',
														}}
													>
														Next 6 months
													</Typography>
												</Stack>
											</Box>
										</Box>
									</BudgetCard>
								</Grid>
								<Grid size={{ xs: 12, md: 6, lg: 3 }}>
									<BudgetCard heading="Payments Overview">
										<ul
											className={
												styles.paymentOverviewList
											}
										>
											{paymentOverviewData.map(
												(item, id) => {
													return (
														<li key={id}>
															<div
																className={
																	styles.icon
																}
															>
																<img
																	src={
																		item.icon
																	}
																	alt=""
																/>
															</div>
															<div
																className={
																	styles.content
																}
															>
																<Typography variant="h5">
																	{
																		item.status
																	}
																</Typography>
																<Typography data-cy={item.status} variant="h6">
																	{item.count}
																</Typography>
															</div>
														</li>
													)
												}
											)}
										</ul>
									</BudgetCard>
								</Grid>
								<Grid size={{ xs: 12, md: 12, lg: 12 }}>
									<BudgetCard style={{ padding: '0' }}>
										<CategoryTab />
									</BudgetCard>
								</Grid>
							</Grid>
						</CustomTabPanel>
						<CustomTabPanel
							value={value}
							index={1}
							className={styles.content}
						>
							<BudgetCard heading="Payments">
								<PaymentTable />
							</BudgetCard>
						</CustomTabPanel>
					</div>
				</Box>
			</div>
		</>
	)
}
